// extracted by mini-css-extract-plugin
export var anchor = "_4n-0";
export var discard = "_4n-4";
export var muiTooltipTooltip = "_4n-6";
export var notificationBar = "_4n-3";
export var saveButtonHoverSlotWrapper = "_4n-5";
export var show = "_4n-2";
export var spacer = "_4n-1";